import { render, staticRenderFns } from "./ApplicationInformation.vue?vue&type=template&id=a89b7782&scoped=true"
import script from "./ApplicationInformation.vue?vue&type=script&lang=ts"
export * from "./ApplicationInformation.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationInformation.vue?vue&type=style&index=0&id=a89b7782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b7782",
  null
  
)

export default component.exports